export default __webpack_public_path__ + "static/media/social_icon_ikara_new.6faad88b.jpg";